import { DescriptionPanel } from '../domain';
import { Point } from '@view-model/models/common/basic';
import type { CommandManager } from '@model-framework/command';
import { CompositeCommand, CreateCommand } from '@model-framework/command';
import { ObjectRepository } from '@framework/repository';
import { RTDBPath } from 'balus-common';
import type { DescriptionPanelId, ModelId, ViewModelId } from 'balus-common';

export class DescriptionPanelCreationOperation {
  static create({
    viewModelId,
    modelId,
    commandManager,
    position,
  }: {
    viewModelId: ViewModelId;
    modelId: ModelId;
    commandManager: CommandManager;
    position: Point;
  }): DescriptionPanelId {
    const panel = DescriptionPanel.buildNew();
    const { id } = panel;

    const panelRepository = new ObjectRepository(
      DescriptionPanel,
      RTDBPath.DescriptionPanel.panelPath(viewModelId, modelId, id)
    );
    const positionRepository = new ObjectRepository(
      Point,
      RTDBPath.DescriptionPanel.positionPath(viewModelId, modelId, id)
    );

    const command = new CompositeCommand(
      new CreateCommand(panel, panelRepository),
      new CreateCommand(position, positionRepository)
    );
    commandManager.execute(command);

    return id;
  }
}
